<template>
	<div content>
		<p>
			<strong>一、募投项目可行性研究对准上市企业的重要性</strong>
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、企业IPO后发展战略的实施和业绩的增长主要依赖于募投项目的顺利实施。因此，募投项目的必要性和可行性是上市审批机构判
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;断企业是否可以上市的重要依据；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、投资者会根据企业募投项目的发展前景判断企业的投资价值和增长潜力；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、募投项目必须符合公司实际情况，即要与企业的资源和各项能力相匹配，过高或过低都可能被否决；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、募投资金项目必须符合外部复杂的市场环境，否则有可能使公司遭受重大损失；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、技术是否可以产业化，需要从产业链的高度加以充分论证。
		</p>
		<p>
			<strong>二、美信咨询上市前IPO及再融资募投可研服务内容</strong>
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、根据上市审批机构审核思路和企业自身特点为准上市企业筛选和设计募投项目；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、论证募投项目实施的有利条件、可行性及必要性；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、为募投项目的审批、核准或备案提供项目可行性研究报告；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、协助准上市企业将募投项目在发改委进行备案；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、协助券商撰写招股说明书中“第十一节 募集资金运用”章节的内容；&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6、协助券商做好证监会要求的关于“募集资金运用”章节的工作底稿；&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7、协助准上市企业把握募投项目实施时机并及时进行相关准备工作；
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8、向上市审批机构描述准上市企业募投项目前景、盈利预期及相应财务指标；&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9、向上市审批机构描述募投项目的风险及应对或控制措施。
		</p>
		<p>
			<strong>三、美信咨询在IPO及再融资募投可研方面的优势</strong>
		</p>
		<p>
			<strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、科学严谨的研究方法</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）严格的项目质量控制流程；&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）专业的财务测算系统；&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）提供详实的工作底稿。
		</p>
		<p>
			<strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、对上市审批机构发审规则和发审委关注点的深入理解</strong>
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;募投可研报告不同于一般的项目可行性报告，其不仅仅用于发改委备案，更重要的是用于招股说明书的撰写，所以不了解上市审
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;批机构发审关注点的传统设计院大都无法提供符合审批要求的募投可研报告。美信咨询对上市审批机构的发审规则非常熟悉，在
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;项目执行时可以充分考虑审批机构发审时的关注点。
		</p>
		<p>
			<strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、专业的项目团队</strong>
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;募投可研的主要工作内容是对项目投资进行合理安排并对项目经济收益进行科学估算，因此需要项目执行人员具有财务管理专业
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;背景和丰富的从业经验，才能高质量地完成财务测算部分的工作。美信咨询拥有多名资深财务从业人员，其中CPA 9名，CFA 11&nbsp;
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名，ACCA 6名。
		</p>
		<p>
			<strong>四、美信咨询募投项目可行性研究实施流程</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		</p>
		<p>
			<img :src="image" width="551" height="454" />
			<br />
			<strong>五、美信咨询募投项目可行性研究报告框架</strong>
		</p>
		<p>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第一章 总 论
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第二章 募投项目未来市场前景分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第三章 募投项目采取的技术工艺分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第四章 募投项目建设方案
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第五章 项目实施地及配套条件
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第六章 环保、消防、节能及职业安全卫生
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第七章 组织机构、劳动定员和人员培训
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第八章 预计募集资金数额以及使用计划
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第九章 募投项目建设规模与建设进度计划
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十章 与募投项目相匹配的各项能力分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十一章 募投项目未来3-5年的发展目标
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十二章 募投项目的经济效益分析
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十三章 募投建设项目风险分析及控制措施
			<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第十四章 可行性研究结论
		</p>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				image: require('@/assets/ipo.2.jpg')
			};
		}
	}
</script>